const { getEvaluationStatusChip } = require('utils/evaluations')

export const filterBarObject = (name, filters, toggleFilterFunction) => {
  return {
    label: getEvaluationStatusChip(name),
    value: filters.indexOf(name) === -1,
    onChange: () => toggleFilterFunction(name),
  }
}
